<div class="container status pago-error pago-pendiente">
  <div class="row justify-content-center">
    <div class="col-12 col-lg-6 text-center">
      <i class="fal fa-clock status__icon"></i>
      <div
        *ngIf="
          contenido && contenido.titulo && intervaloConsultarEstadoPago !== 0
        "
        class="status__title my-4"
      >
        <span class="mr-1">
          {{ contenido.titulo[0].text }}
        </span>
        <countdown
          #countdown
          [config]="{
            leftTime: intervaloConsultarEstadoPago,
            format: 'ss'
          }"
          (event)="handleChangeCountdown($event)"
        ></countdown>
        <span class="ml-1">
          segundos
        </span>
      </div>
      <div
        *ngIf="intervaloConsultarEstadoPago === 0"
        [innerHTML]="contenidoInformacionReintentos"
      ></div>
      <div
        *ngIf="contenido && contenido.descripcion"
        class="contenedor-info-estado-pago"
      >
        <i
          class="far fa-exclamation-triangle contenedor-info-estado-pago__icono"
        ></i>
        <div [innerHTML]="contenidoDescripcion"></div>
      </div>
      <app-resumen-pago
        [referencia]="pago.referencia"
        [resumenesDePago]="resumenesDePago"
      ></app-resumen-pago>
    </div>
    <div class="col-12 d-flex flex-column align-items-center my-5">
      <a (click)="regresarAlComercio(pago.urlRetorno)" class="go-back"
        >Regresar al comercio</a
      >
      <b class="inquietudes">Si tienes dudas escríbenos a:</b>
      <label class="email">operacionesdigitales@suramericana.com.co</label>
    </div>
    <div class="col-12 text-center my-3">
      <a href="https://www.placetopay.com/web/" target="_blank">
        <img
          src="https://static.placetopay.com/placetopay-logo.svg"
          class="attachment-0x0 size-0x0 logo-placetopay"
          alt="placetopay"
          loading="lazy"
        />
      </a>
    </div>
  </div>
</div>
